// Core
import React from 'react';
// Styles
import './Nav.css';

const Nav = props => {
    return (
        <nav>
            <h2 hidden>{props.label ? props.label : 'Navigation'}</h2>
            <ol>{props.children}</ol>
        </nav>
    );
};

export default Nav;



// WEBPACK FOOTER //
// ./src/templates/Nav/Nav.js